export const isInIframe = () => {
  return window.self !== window.top;
};